import { Alert, Button } from '@mui/material';
import { Link as RouterLink } from 'react-router-dom';
import useAuth from '../hooks/useAuth';
import { usePlans } from '../api/billing';
import { PATH_DASHBOARD } from '../routes/paths';

// An account nobody is paying for is read-only for program actions — sites,
// team, invites, requirements (backend requireProgramActive) — until a plan is
// chosen. Documents and the safety registers still work.
// Shown to the people who can act on it: the owner and their office admins.
const CAN_CHOOSE = new Set(['builder', 'subcontractor', 'officeadmin']);

export default function ReadOnlyBanner() {
  const { user } = useAuth();
  const { data } = usePlans();
  if (!user || !CAN_CHOOSE.has(user.role ?? '') || data?.accountState !== 'free') return null;
  return (
    <Alert
      severity="warning"
      sx={{ mb: 2 }}
      action={
        <Button color="inherit" size="small" component={RouterLink} to={PATH_DASHBOARD.dash.plans}>
          Choose a plan
        </Button>
      }
    >
      Until a plan is chosen, sites, team members, invites and document requirements are
      view-only. Your documents and safety registers keep working as normal.
    </Alert>
  );
}
